export default __webpack_public_path__ + "static/media/simon.6d20099c.png";